var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoteJobsOn = function SvgRemoteJobsOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06F",
    fillRule: "evenodd",
    d: "M2 4.895C2 3.848 2.895 3 4 3h16c1.105 0 2 .848 2 1.895v10.42c0 1.047-.895 1.896-2 1.896H4c-1.105 0-2-.849-2-1.895zm8.5 14.21h3v-1.894h2v1.894H19V21H5v-1.895h3.5v-1.894h2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M8.5 9.408h7"
  })));
};
export { SvgRemoteJobsOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZpbGxlZC8gUmVtb3RlcyI+CjxwYXRoIGlkPSJVbmlvbiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDQuODk0NzRDMiAzLjg0ODMgMi44OTU0MyAzIDQgM0gyMEMyMS4xMDQ2IDMgMjIgMy44NDgzIDIyIDQuODk0NzRWMTUuMzE1OEMyMiAxNi4zNjIyIDIxLjEwNDYgMTcuMjEwNSAyMCAxNy4yMTA1SDRDMi44OTU0MyAxNy4yMTA1IDIgMTYuMzYyMiAyIDE1LjMxNThWNC44OTQ3NFpNMTAuNSAxOS4xMDUySDEzLjVWMTcuMjEwNkgxNS41VjE5LjEwNTJIMTlWMjFINVYxOS4xMDUySDguNVYxNy4yMTA2SDEwLjVWMTkuMTA1MloiIGZpbGw9IiMwMDY2RkYiLz4KPHBhdGggaWQ9IlZlY3RvciAxODgyIiBkPSJNOC41IDkuNDA3NTlIMTUuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjwvZz4KPC9zdmc+Cg==";